export default __webpack_public_path__ + "/images/molecules.png";